import styled from 'styled-components';
import { spacing } from '../../constants/spacing.js';
import { styles } from '../../constants/styles.js';

var wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__wrapper",
  componentId: "sc-1vry0u3-0"
})(["display:flex;flex-direction:row;& > *:not(:last-child){padding-right:", ";", "{padding-right:", ";}}"], spacing.xxs, styles.breakpoint.s, spacing.xs);

export { wrapper };
